import { ApiOperationBase } from 'api/rtk-api'
import { PresentationalTable } from 'components/core-v2'
import { Currency, formatCurrencyFull } from 'utilities/currency'

interface Props {
  operation: ApiOperationBase
}

export const CashTransactionTable = ({ operation }: Props) => {
  const rows = (operation.cashTransactions ?? [])
    .filter(x => x.instrumentType !== 'ZcbCurve')
    .map(op => [
      op.instrumentId,
      new Date(op.createdDate).toLocaleString(undefined, {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric'
      }),
      op.shares.toFixed(6),
      formatCurrencyFull(op.value, op.currency as Currency)
    ])
  return (
    <PresentationalTable
      headerRow={['Instrument ID', 'Exe. Date', 'Units', 'Amount']}
      rowOptions={[
        { width: '35%' },
        { width: '25%' },
        { width: '20%', align: 'right' },
        { width: '20%', align: 'right' }
      ]}
      rows={rows}
    />
  )
}
